import { Box, Divider, Grid, Paper, Tab, Tabs } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import Global from '../../../customlib/Global';

class TeleDiChatCustomerResponseTimeReportAverageMobile extends Component {
    state = { 
        selectedTab: "PERJAM"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Average Di Chat Customer"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props} />
                    <Box>
                        {this.props.state.contactLeads?.map(lead => {
                            return (
                            <Box elevation={2} sx={{mb: "5px", padding: "5px"}}>
                                <Grid container spacing={1}>
                                    <Grid item xs={8}>
                                        <strong>{lead.salesName}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        <strong>AVG : {Global.formatTime(lead.avgResponseTime < 0 ? 0 : lead.avgResponseTime)}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"left"}>
                                        Leads<br />
                                        <strong>{lead.leads.length}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"center"}>
                                        &lt; 1 Menit<br />
                                        <strong>{lead.under1Minute}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        &gt; 1 Menit<br />
                                        <strong>{lead.upper1Minute}</strong>
                                    </Grid>
                                    
                                </Grid>
                                <Divider sx={{mt: "8px"}} />
                            </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Box>
        );
    }
}
 
export default TeleDiChatCustomerResponseTimeReportAverageMobile;